import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthorizationGuard } from "src/app/core/guards/authorization.guard";
import { AuthenticationGuard } from "src/app/core/guards/authentication.guard";
import { DashboardHomeComponent } from "./dashboard-home.component";
import { SfcDashboardClientComponent } from "./sfc-dashboard-client/sfc-dashboard-client.component";
import { SfcDashboardAdminComponent } from "./sfc-dashboard-admin/sfc-dashboard-admin.component";
import { SfcDashboardServiceComponent } from "./sfc-dashboard-service/sfc-dashboard-service.component";

const routes: Routes = [
    {
        path: '', component: DashboardHomeComponent,
        canActivate: [AuthenticationGuard, AuthorizationGuard],
        data:{roles:['SF_ADMIN','ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_CLIENT', 'ROLE_SELLER', 'ROLE_SERVICE']}
    },
    {
        path: 'admin', component: SfcDashboardAdminComponent,
        canActivate: [AuthenticationGuard, AuthorizationGuard],
        data:{roles:['SF_ADMIN','ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SELLER']}
    },
    {
        path: 'service', component: SfcDashboardServiceComponent,
        canActivate: [AuthenticationGuard, AuthorizationGuard],
        data:{roles:['SF_ADMIN','ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SELLER', 'ROLE_SERVICE']}
    },
    {
        path: 'client', component: SfcDashboardClientComponent,
        canActivate: [AuthenticationGuard, AuthorizationGuard],
        data:{roles:['SF_ADMIN','ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_CLIENT', 'ROLE_SELLER', 'ROLE_SERVICE']}
    },

  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
  })
  export class DashboardRoutingModule { }
